module.exports = __webpack_public_path__ + "img/circle-7.51f78b48.svg";